<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-page-header @back="goBack" :content="id ? '编辑供应商' : '添加供应商'"></el-page-header>
		<el-form label-position="right" :rules="rules" ref="ruleForm" :model="item" label-width="auto">
			<el-form-item label="供应商名称" prop="name">
				<el-input v-model="item.name" placeholder="请输入名称"></el-input>
			</el-form-item>
			<el-form-item label="手机号码" prop="mobile">
				<el-input v-model="item.mobile" placeholder="请输入手机号码" :disabled="id? true : false"></el-input>
			</el-form-item>
			<el-form-item label="短信费用比例" prop="sms_fee">
				<el-input style="width: 200px" v-model="item.sms_fee" placeholder="请输入短信费用比例"></el-input>
				<span style="margin-left: 10px">%</span>
			</el-form-item>
			<el-form-item label="技术服务费比例" prop="service_fee">
				<el-input style="width: 200px" v-model="item.service_fee" placeholder="请输入技术服务费比例">
				</el-input>
				<span style="margin-left: 10px">%</span>
			</el-form-item>

			<el-form-item label="登陆密码" prop="password">
				<el-input show-password v-model="item.password" placeholder="请输入登陆密码"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button size="big" type="primary" @click="checkSubmit">保存</el-button>
			</el-form-item>
			<el-form-item>
				<el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
					<span>您确认保存嘛</span>
					<span slot="footer" class="dialog-footer">
						<el-button @click="dialogVisible = false">取 消</el-button>
						<el-button type="primary" @click="submit">确 定</el-button>
					</span>
				</el-dialog>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				item: {},
				isLoad: false,
				id: this.$route.query.id,
				dialogVisible: false,
				rules: {
					name: [{
						required: true,
						message: '供应商名称不存在',
						trigger: 'blur'
					}, ],
					mobile: [{
						required: true,
						validator: this.$check.mobile,
						trigger: 'blur'
					}, ],
					sms_fee: [{
						required: true,
						message: '请输入短信费用比例',
						trigger: 'blur'
					}, ],
					service_fee: [{
						required: true,
						message: '请输入技术服务费比例',
						trigger: 'blur'
					}, ],
					password: [{
						required: this.$route.query.id ? false: true,
						message: '登陆密码不存在',
						trigger: 'blur'
					}, ]
				}
			}
		},
		created() {
			if (this.id) {
				this.loadData()
			}
		},
		methods: {
			loadData() {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				this.axios.post('/admin/supplier/detail', {
					// 请求查询的数据 id为undefined的时候没有值
					id: this.id
				}).then(res => {
					this.isLoad = !this.isLoad
					// item是基础信息
					this.item = res.data.detail
					this.item.password = ''
				}).catch(() => {
					this.isLoad = !this.isLoad
				})
			},
			// 后退一步
			goBack() {
				this.$router.back(-1)
			},
			checkSubmit() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.dialogVisible = true
					} else {
						this.$message.warning("请检查表单信息是否正确");
						return false;
					}
				});
			},

			// 提交
			submit() {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				this.dialogVisible = false
				let url = ''
				if (this.id) {
					url = '/admin/supplier/update'
					this.item.id = this.id
				} else {
					url = '/admin/supplier/add'
				}
				this.axios.post(url, this.item)
					.then(() => {
						this.isLoad = !this.isLoad
						this.$message.success({
							message: '保存成功'
						});
						this.goBack()
					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
			},
		}
	}
</script>
<style scoped>
</style>
